import React, {useState} from 'react';
import {TextInputMaskProps} from 'react-native-text-input-mask';
import theme from '../../../../../global/styles/legacy/theme';

import {
  Container,
  InputContainer,
  Input,
  Error,
  ShowPassword,
  Icon,
} from './styles';

interface IAuthInput extends TextInputMaskProps {
  error?: string;
  errorStyle?: boolean;
  passwordInput?: boolean;
}

export function AuthInput({
  error,
  errorStyle = false,
  passwordInput = false,
  ...rest
}: IAuthInput) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Container>
      <InputContainer error={errorStyle}>
        {passwordInput ? (
          <>
            <Input
              autoCorrect={false}
              {...rest}
              error={errorStyle}
              placeholderTextColor={theme.colors.placeholder}
              secureTextEntry={!showPassword}
            />
            <ShowPassword onPress={() => setShowPassword(!showPassword)}>
              <Icon name={showPassword ? 'eye-off' : 'eye'} />
            </ShowPassword>
          </>
        ) : (
          <Input
            {...rest}
            error={errorStyle}
            placeholderTextColor={theme.colors.placeholder}
          />
        )}
      </InputContainer>
      {error ? <Error>{error}</Error> : <></>}
    </Container>
  );
}
